import React from "react";

export default function NotificationsIcon() {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.625 15.7083H17.8333L16.3698 14.2449C15.9729 13.848 15.75 13.3097 15.75 12.7484V9.45834C15.75 6.73705 14.0108 4.42197 11.5833 3.56397V3.20833C11.5833 2.05774 10.6506 1.125 9.49996 1.125C8.34937 1.125 7.41663 2.05774 7.41663 3.20833V3.56397C4.98914 4.42197 3.24996 6.73705 3.24996 9.45834V12.7484C3.24996 13.3097 3.02699 13.848 2.6301 14.2449L1.16663 15.7083H6.37496M12.625 15.7083V16.75C12.625 18.4759 11.2258 19.875 9.49996 19.875C7.77407 19.875 6.37496 18.4759 6.37496 16.75V15.7083M12.625 15.7083H6.37496"
        stroke="#3F3F46"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
